'use strict';
moduleConfig.registerModule('eclipseApp.boldChat', ['eclipseApp.core']);
